// extracted by mini-css-extract-plugin
export default {"idUploadOA":"styles_idUploadOA__hrev-"};